import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { Snackbar } from 'react-native-paper';
import { COLORS } from '../../constants';
import { setData } from '../../utils/storage';

const SnackbarMessageCommon = ({ visible, message }) => {

  const [snackbarVisible, setSnackbarVisible] = useState(false);
  
  return (
    <View style={styles.snackbarContainer}>
      <Snackbar
        style={styles.snackbar}
        wrapperStyle={{ top: 0 }}
        visible={visible}
        duration={3000}
        onDismiss={() => {
          visible = false;
        }}
      >
        <Text style={styles.snackbarTextStyle}>{message}</Text>
      </Snackbar>
    </View>
  );
};

const styles = {
  snackbarContainer: {
    width: '100%',
    height: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 1,
  },
  snackbar: {
    backgroundColor: COLORS.textDark,
  },
  snackbarTextStyle: {
    color: COLORS.textLight,
    textAlign: 'center',
    fontSize: 18,
  },
};

export default SnackbarMessageCommon;